import c from './assets/sass/container.module.scss'

export const Container = ({ children, customMaxWidth = null }) => {
    return (
        <div
            className={c.component}
            style={customMaxWidth ? { maxWidth: `${customMaxWidth}px` } : null}
        >
            {children}
        </div>
    )
}
